import { APP } from '@/shared/config'
import { isProblem } from '@/shared/api/problem'
import { classifyError } from './classify'

export type ErrorReportInput = {
  error: unknown
  /**
   * Переопределённый стек, например расшифрованный по сорсмапу (см. `symbolicateStack`).
   * Если передан — печатаем его вместо `error.stack`.
   */
  stack?: string
  componentStack?: string
  route?: string
  requestId?: string | null
}

export function buildErrorReport(input: ErrorReportInput): string {
  const { error, stack, componentStack, route, requestId } = input
  const kind = classifyError(error)

  const lines: string[] = [
    '=== Prima Bookings · отчёт об ошибке ===',
    `Когда:        ${new Date().toISOString()}`,
    `Тип:          ${kind}`,
    `Версия:       ${APP.version} (${APP.commit}, собрано ${APP.builtAt})`,
    `Адрес:        ${route ?? (typeof location !== 'undefined' ? location.pathname + location.search : '—')}`,
    `Request-Id:   ${requestId ?? '—'}`,
    `Браузер:      ${typeof navigator !== 'undefined' ? navigator.userAgent : '—'}`,
    '',
  ]

  if (isProblem(error)) {
    lines.push(
      '--- Ответ сервера ---',
      `status:   ${error.status}`,
      `type:     ${error.type}`,
      `title:    ${error.title}`,
      `detail:   ${error.detail ?? '—'}`,
      `instance: ${error.instance ?? '—'}`,
    )
  } else if (error instanceof Error) {
    lines.push('--- Ошибка ---', `${error.name}: ${error.message}`, '', stack ?? error.stack ?? '(стека нет)')
  } else {
    // Не Error и не Problem — например, кто-то бросил голый объект или строку.
    // String() дал бы «[object Object]», то есть ровно ту бесполезность, от которой
    // отчёт и должен спасать. Сериализуем содержимое; если объект циклический —
    // откатываемся на String(), но хотя бы попытавшись.
    lines.push('--- Ошибка ---', describeUnknown(error))
  }

  if (componentStack) {
    lines.push('', '--- Дерево компонентов ---', componentStack.trim())
  }

  return lines.join('\n')
}

/** Значение, брошенное вместо Error: печатаем содержимое, а не «[object Object]». */
function describeUnknown(value: unknown): string {
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value, null, 2) ?? String(value)
  } catch {
    // Циклическая ссылка или несериализуемое поле.
    return String(value)
  }
}
